import {
    Search,
    DraftingCompass,
    Code2,
    Bot,
    Rocket,
} from "lucide-react";
import { SectionHeading } from "@/components/common/SectionHeading";

const steps = [

    {

        icon: Search,

        title: "Discover",

        description:
            "Analyse existing business processes and identify automation opportunities.",

    },

    {

        icon: DraftingCompass,

        title: "Design",

        description:
            "Create a scalable digital transformation roadmap aligned with business goals.",

    },

    {

        icon: Code2,

        title: "Build",

        description:
            "Develop secure, cloud-native enterprise software tailored to your organisation.",

    },

    {

        icon: Bot,

        title: "Automate",

        description:
            "Deploy AI agents, workflow automation and intelligent integrations.",

    },

    {

        icon: Rocket,

        title: "Scale",

        description:
            "Optimise operations continuously using analytics and business intelligence.",

    },

];

export default function TransformationJourney() {

    return (

        <section className="py-24">

            <div className="mx-auto max-w-7xl px-6">

                <SectionHeading

                    eyebrow="Transformation Journey"

                    title="From Manual Operations to Intelligent Enterprise"

                    description="Our proven approach helps organisations modernise operations and unlock long-term business value."

                />

                <div className="mt-16 grid gap-8 lg:grid-cols-5">

                    {steps.map((step, index) => {

                        const Icon = step.icon;

                        return (

                            <div
                                key={step.title}
                                className="relative rounded-3xl border bg-card p-8"
                            >

                                {index !== steps.length - 1 && (

                                    <div
                                        className="absolute left-full top-10 hidden h-px w-8 bg-border lg:block"
                                    />

                                )}

                                <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-primary/10">

                                    <Icon className="h-7 w-7 text-primary"/>

                                </div>

                                <h3 className="mt-6 text-xl font-semibold">

                                    {step.title}

                                </h3>

                                <p className="mt-3 text-muted-foreground leading-7">

                                    {step.description}

                                </p>

                            </div>

                        );

                    })}

                </div>

            </div>

        </section>

    );

}